import { rsaEncodeString, getSensitiveList } from '@utils'
import Store from 'store'
import { b64Encode } from '@utils/lib'
import UserStore from '@stores/UserStore'
import CommonApi, { IHome } from '@services/api/Common'
import { directTo, getHashRoute } from '@utils/url'
import { Login } from '@services/api'
import { CaptchaType } from '@components/SliderCaptcha'
import { dataType } from '../components/AppListDialog'
import { IProps as ILoginProps } from './index'
import { getQueryParams } from '@utils/url'
import { transform } from '@utils/intl_lang'
import { NEED_BAND_STORAGE_KEY } from '@const/login'
export const passSeperator = '@pass@'
export const isEqualFakePwd = (password: string) =>
  password.includes('********')
export const rememberPwd = (password: string, username: string) => {
  if (isEqualFakePwd(password)) {
    return
  }
  const pwd = rsaEncodeString(password.trim())
  const passwordInfo = `${username}${passSeperator}${pwd}${passSeperator}${password.length}`
  const loginInfo = rsaEncodeString(username.trim() + ',pwd=' + password.trim())
  Store.set('loginInfo', loginInfo)
  Store.set('passwordInfo', b64Encode(passwordInfo))
}
export const deletePwd = () => {
  Store.set('loginInfo', '')
  Store.set('passwordInfo', '')
}
export const queryOperationList = async () => {
  const result = await Login.queryOperationList()
  if (result.code === 0) {
    Store.set('operationList', result.body)
    UserStore.setOperationList(result.body)
  }
}

export const getHomeList = async (
  { history, AppStore }: Pick<ILoginProps, 'history' | 'AppStore'>,
  unnormalLogin?: boolean
) => {
  // 敏感词数据获取
  getSensitiveList()
  if (unnormalLogin) {
    AppStore.setTheme('', 0)
    directTo(history)
    return
  }
  const { code, message, body } = (await CommonApi.getHomeList()) as IHome
  // console.log(window.location)
  if (+code === 0) {
    // if (!body.length) {
    //   history.push('/noPermission/2')
    //   return
    // }
    // 个性化登录页的情况下使用个性化登录首页否则使用上一个首页
    const homeId = AppStore.individuationKey
      ? AppStore.individualInfo.pageId
      : Store.get('homeId')
    const home = body.find(v => v.pageId === homeId) || body[0]
    const { pageId = '', isOpenPcVersion = 0 } = home || {}
    AppStore.setTheme(pageId, isOpenPcVersion)
    AppStore.setHomeList(body)
    const params = getQueryParams(location.href.split('?')[1])
    const hashRoute = getHashRoute()
    if (
      hashRoute.startsWith('login') &&
      params.trainingItemId &&
      +params.itemEnterpriseFlag === 2
    ) {
      return
    }
    directTo(history)
  } else {
    global.$message(message)
  }
}

export const isCaptchaPopupShow = () => {
  const popup = document.querySelector('.geetest_popup')
  if (!popup) {
    return false
  }
  return window.getComputedStyle(popup).display === 'block'
}

export const hideGeetestPopup = (
  captcha: CaptchaType | null,
  targetEl: any
) => {
  if (captcha) {
    const popup = document.querySelector('.geetest_popup') as HTMLDivElement
    if (popup && isCaptchaPopupShow() && captcha && !popup.contains(targetEl)) {
      captcha.hide()
    }
  }
}

const emptyString = () => ''

export const initialState = {
  username: '',
  password: emptyString(),
  initialPwd: emptyString(),
  captcha: '',
  rememberPwd: false,
  captchaUrl: '',
  appListDialogVisible: false,
  loginLoading: false,
  captchaError: false,
  usernameOrPwdError: false,
  dialogTitle: transform('Login_group'),
  dialogData: [] as dataType,
  dialogType: 0,
  loginType: '0',
  phoneNum: '',
  slideVisible: false,
  dialogVisible: false,
  forceLoginToken: '',
  isCancelLogin: false,
  checkAgreement: false,
  isEnterpriseShow: false,
  loadingFirst: false,
  enterpriseCode: '',
  enterpriseMail: '',
  enterpriseWord: '',
  imgCaptcha: '', // 图形验证码
  imgVisible: false, // 图形验证码显示
  isPasswordType: true, // 是否是账密登录方式
  count: 0, // 短信倒计时
  stepOne: true, // 企业代码登录第一步
  enterpriseAppId: '' // 企业代码登录入参
}

export const OPEN_PLATFORM = 'openPlatform'
